var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoldStarR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.0076 3.05431C11.32 2.09295 12.68 2.09295 12.9924 3.05431L14.4599 7.57077C14.5996 8.00071 15.0002 8.2918 15.4523 8.2918H20.2012C21.212 8.2918 21.6323 9.58531 20.8145 10.1795L16.9726 12.9708C16.6069 13.2365 16.4538 13.7075 16.5935 14.1374L18.061 18.6539C18.3734 19.6153 17.2731 20.4147 16.4553 19.8205L12.6133 17.0292C12.2476 16.7635 11.7524 16.7635 11.3867 17.0292L7.54473 19.8205C6.72695 20.4147 5.62662 19.6153 5.93898 18.6539L7.40647 14.1374C7.54616 13.7075 7.39313 13.2365 7.0274 12.9708L3.18548 10.1795C2.36769 9.58531 2.78798 8.2918 3.79882 8.2918H8.5477C8.99976 8.2918 9.40041 8.00071 9.54011 7.57077L11.0076 3.05431Z",
  fill: "#FF8C00"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoldStarR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gold-star-r.198174e099a504381c47709b63c32791.svg";